/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewSupplyChainMembersFromExcelRequest } from '../../models/new-supply-chain-members-from-excel-request';

export interface NewSupplyChainMembersParseExcel$FormData$Params {
      body?: {
'request': NewSupplyChainMembersFromExcelRequest;
}
}

export function newSupplyChainMembersParseExcel$FormData(http: HttpClient, rootUrl: string, params?: NewSupplyChainMembersParseExcel$FormData$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, newSupplyChainMembersParseExcel$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

newSupplyChainMembersParseExcel$FormData.PATH = '/api/supply-chain/members/parse-excel';
